/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online whitespace cleaner. Trim each line, collapse multiple spaces and tabs into one, and remove blank lines from your text. Works in your browser.`)
};

const es_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiador de espacios en blanco en línea gratuito. Recorta cada línea, colapsa múltiples espacios y tabulaciones en uno, y elimina líneas en blanco del texto. Funciona en tu navegador.`)
};

const de_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Leerzeichen-Bereiniger. Trimmen Sie jede Zeile, fassen Sie mehrere Leerzeichen und Tabulatoren zu einem zusammen und entfernen Sie Leerzeilen aus Ihrem Text. Funktioniert in Ihrem Browser.`)
};

const nl_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online witruimte opruimer. Trim elke regel, vouw meerdere spaties en tabs in en verwijder lege regels uit uw tekst. Werkt in uw browser.`)
};

const fr_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyeur d'espaces blancs gratuit en ligne. Supprimez les espaces de chaque ligne, réduisez plusieurs espaces et tabulations en un seul, et supprimez les lignes vides de votre texte. Fonctionne dans votre navigateur.`)
};

const it_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulitore di spazi bianchi gratuito online. Taglia ogni riga, comprimi più spazi e tabulazioni in uno e rimuovi le righe vuote dal testo. Funziona nel tuo browser.`)
};

const pt_br2_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de espaços em branco online gratuito. Aparar cada linha, colapsar múltiplos espaços e abas em um, e remover linhas em branco do seu texto. Funciona no seu navegador.`)
};

const pt_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de espaços em branco online gratuito. Apare cada linha, colapsar múltiplos espaços e abas numa só, e remova linhas em branco do seu texto. Funciona no seu navegador.`)
};

const ja_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンラインホワイトスペースクリーナー。各行をトリムし、複数のスペースとタブを1つに圧縮し、テキストから空白行を削除します。ブラウザで動作します。`)
};

const zh_wsc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线空白字符清理工具。修剪每一行，将多个空格和制表符合并为一个，并删除文本中的空行。在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_meta_description", locale)
	if (locale === "en") return en_wsc_meta_description(inputs)
	if (locale === "es") return es_wsc_meta_description(inputs)
	if (locale === "de") return de_wsc_meta_description(inputs)
	if (locale === "nl") return nl_wsc_meta_description(inputs)
	if (locale === "fr") return fr_wsc_meta_description(inputs)
	if (locale === "it") return it_wsc_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_meta_description(inputs)
	if (locale === "pt") return pt_wsc_meta_description(inputs)
	if (locale === "ja") return ja_wsc_meta_description(inputs)
	return zh_wsc_meta_description(inputs)
};